import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

export const viewSharedProps = {
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  isAnimated: PropTypes.bool,
  text: PropTypes.string,
  type: PropTypes.string,
  components: PropTypes.object,
  period: PropTypes.number,
  fqPeriod: PropTypes.number,
  palette: PropTypes.array,
  chartMode: PropTypes.string,
  defaults: PropTypes.object,
  reportParams: PropTypes.object,
  config: PropTypes.object,
  answer: answerPropType,
  onModelChange: PropTypes.func
}
